import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, TrackingPage, ResetItemTrackingEvent, TrackingEventName, TrackingEventCategory } from "./tracking";

interface ResetItemFunction {
  (): void;
}

interface UseTrackResetItemFunctionArgs {
  readonly page: TrackingPage;
  readonly country: Country;
  readonly segment: Segment;
  readonly checkoutId: string | undefined;
  readonly checkoutItemId: string;
  readonly tradename: Tradename;
}
interface UseTrackResetItemFunction {
  (agrs: UseTrackResetItemFunctionArgs): ResetItemFunction;
}

const useTrackResetItem: UseTrackResetItemFunction = ({
  page,
  country,
  segment,
  checkoutId,
  tradename,
  checkoutItemId,
}) => {
  const emitUserEvent = useEmitUserEvent<ResetItemTrackingEvent>();

  const resetItem: ResetItemFunction = useCallback(() => {
    if (!checkoutId) {
      return;
    }

    const resetItemTrackingEvent: ResetItemTrackingEvent = {
      event: TrackingEventName.RESET_ITEM,
      eventCategory: TrackingEventCategory.NAVIGATION,
      section: `${PROJECT}_${page}`,
      store: country,
      segment,
      checkoutId,
      tradename,
      checkoutItemId,
    };

    emitUserEvent(resetItemTrackingEvent);
  }, [checkoutId, tradename, checkoutItemId, country, emitUserEvent, page, segment]);

  return resetItem;
};

export { useTrackResetItem };
